import SvgIcon from "@mui/material/SvgIcon";
import ForwardIcon from "@mui/icons-material/Forward";

const ForwardSVG = () => {
  return <SvgIcon color="success" component={ForwardIcon} sx={{ fontSize: "60px", color: "#77bf43" }} />;
};

export default ForwardSVG;
